module.exports = __webpack_public_path__ + "static/media/upload.6698ea13.png";